import {Component, Input, OnInit, Type} from '@angular/core';
import {RxComponent} from '../../../core/components/common/rx.component';
import {ModalSize, SmartModalService} from '../../../core/services/smart-modal.service';
import {ProceedDetailsComponent} from '../settlement-proceeds-details/proceed-details.component';

@Component({
    selector: 'itpx-settlement-details',
    templateUrl: './settlement-batch-details.component.html',
    styleUrls: ['./settlement-batch-details.component.css']
})
export class SettlementBatchDetailsComponent extends RxComponent implements OnInit {

    @Input('data') data = null;

    public settlement: any = null;
    private collapseToggleData: any = {};

    constructor(
        private modalService: SmartModalService
    ) {
        super();
    }

    ngOnInit() {
        this.settlement = this.data.batchItem;
    }

    openProceedsDetails() {
        this.modalService.open(
            ProceedDetailsComponent,
            {},
            'Transaction Details',
            ModalSize.Custom,
        )
        .neverError()
        .subscribe(_ => {
            console.log(_);
        });
    }

    onCollapseToggle(name: string) {
        this.collapseToggleData[name] = !this.collapseToggleData[name];

    }

    downloadCSV(data) {
        console.log(data);
    }
}





// WEBPACK FOOTER //
// ./src/app/shared/components/settlements-batch-details/settlement-batch-details.component.ts